var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"form-radio form-inline"},[_c('input',{attrs:{"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('i',{staticClass:"form-icon"}),_vm._v(" "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }